import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  TYPE: {
    name: 'type',
    label: 'Sponsor type:',
    rules: [{ required: true, message: 'Type is required' }],
    options: [
      // TODO: too lazy to remove duplicates. It's almost New Year 😅
      { value: 'World Athletics Partner', label: 'World Athletics Partner' },
      { value: 'World Athletics Media Partner', label: 'World Athletics Media Partner' },
      { value: 'World Athletics Supplier', label: 'World Athletics Supplier' },
    ],
  },
  NAME: {
    name: 'name',
    label: 'Name:',
    placeholder: 'Enter a name',
    rules: [{ required: true, message: 'Name is required' }],
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter a url',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'URL is required' },
    ],
  },
  LIGHT_BACKGROUND: {
    name: 'lightBgLogo',
    label: 'Logo, light background:',
    buttonText: 'CHOOSE A NEW LOGO',
    rules: [{ required: true, message: 'Logo is required' }],
    size: IMAGE_SIZE['100x25'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  DARK_BACKGROUND: {
    name: 'darkBgLogo',
    label: 'Logo, dark background:',
    buttonText: 'CHOOSE A NEW LOGO',
    rules: [{ required: true, message: 'Logo image is required' }],
    size: IMAGE_SIZE['100x25'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  LOGO_SCALE: {
    name: 'logoScale',
    label: 'Logo, show as 2/3 size',
    serialize: (field, values) => {
      const value = values[field.name];

      if (value) return { [field.name]: '2x3' };
      return { [field.name]: '' };
    },
    deserialize: (field, serverData) => {
      if (serverData[field.name]) return { [field.name]: true };
      return { [field.name]: false };
    },
  },
};
